const { createContext } = require("react");

const categoryContext = createContext();

export default categoryContext;